// extracted by mini-css-extract-plugin
export default {"wrapper":"LuckySix_wrapper__rLLGu","frame":"LuckySix_frame__JKrnM","frameMobile":"LuckySix_frameMobile__s7gm+","message":"LuckySix_message__7Kk4Q"};